// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/performance_summary.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/performance_summary.proto.
 */
export const file_chalk_server_v1_performance_summary: GenFile = /*@__PURE__*/
  fileDesc("CiljaGFsay9zZXJ2ZXIvdjEvcGVyZm9ybWFuY2Vfc3VtbWFyeS5wcm90bxIPY2hhbGsuc2VydmVyLnYxIokBChdTaGFyZFBlcmZvcm1hbmNlU3VtbWFyeRIUCgxvcGVyYXRpb25faWQYASABKAkSEAoIc2hhcmRfaWQYAiABKAMSRgolcGVyZm9ybWFuY2Vfc3VtbWFyeV93aXRoX3F1ZXJ5X2NvbmZpZxgDIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QiSgoyTGlzdE9mZmxpbmVRdWVyeVNoYXJkUGVyZm9ybWFuY2VTdW1tYXJpZXNQYWdlVG9rZW4SFAoMc2hhcmRfaWRfaHdtGAEgASgDImsKMExpc3RPZmZsaW5lUXVlcnlTaGFyZFBlcmZvcm1hbmNlU3VtbWFyaWVzUmVxdWVzdBIUCgxvcGVyYXRpb25faWQYASABKAkSDQoFbGltaXQYAiABKAMSEgoKcGFnZV90b2tlbhgDIAEoCSKVAQoxTGlzdE9mZmxpbmVRdWVyeVNoYXJkUGVyZm9ybWFuY2VTdW1tYXJpZXNSZXNwb25zZRJHChVwZXJmb3JtYW5jZV9zdW1tYXJpZXMYASADKAsyKC5jaGFsay5zZXJ2ZXIudjEuU2hhcmRQZXJmb3JtYW5jZVN1bW1hcnkSFwoPbmV4dF9wYWdlX3Rva2VuGAIgASgJQhRaEnNlcnZlci92MTtzZXJ2ZXJ2MWIGcHJvdG8z", [file_google_protobuf_struct]);

/**
 * @generated from message chalk.server.v1.ShardPerformanceSummary
 */
export type ShardPerformanceSummary = Message<"chalk.server.v1.ShardPerformanceSummary"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: int64 shard_id = 2;
   */
  shardId: bigint;

  /**
   * This is called performance_summary in the DB,
   * but is a more comprehensive object where performance_summary is one of the fields
   *
   * @generated from field: google.protobuf.Struct performance_summary_with_query_config = 3;
   */
  performanceSummaryWithQueryConfig?: JsonObject;
};

/**
 * Describes the message chalk.server.v1.ShardPerformanceSummary.
 * Use `create(ShardPerformanceSummarySchema)` to create a new message.
 */
export const ShardPerformanceSummarySchema: GenMessage<ShardPerformanceSummary> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_performance_summary, 0);

/**
 * Not directly used by any other proto, but used as page_token and next_page_token
 * after bytes are base64 encoded
 *
 * @generated from message chalk.server.v1.ListOfflineQueryShardPerformanceSummariesPageToken
 */
export type ListOfflineQueryShardPerformanceSummariesPageToken = Message<"chalk.server.v1.ListOfflineQueryShardPerformanceSummariesPageToken"> & {
  /**
   * @generated from field: int64 shard_id_hwm = 1;
   */
  shardIdHwm: bigint;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardPerformanceSummariesPageToken.
 * Use `create(ListOfflineQueryShardPerformanceSummariesPageTokenSchema)` to create a new message.
 */
export const ListOfflineQueryShardPerformanceSummariesPageTokenSchema: GenMessage<ListOfflineQueryShardPerformanceSummariesPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_performance_summary, 1);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryShardPerformanceSummariesRequest
 */
export type ListOfflineQueryShardPerformanceSummariesRequest = Message<"chalk.server.v1.ListOfflineQueryShardPerformanceSummariesRequest"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: int64 limit = 2;
   */
  limit: bigint;

  /**
   * expected to be an base64 encoded ListOfflineQueryShardPerformanceSummariesPageToken message
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardPerformanceSummariesRequest.
 * Use `create(ListOfflineQueryShardPerformanceSummariesRequestSchema)` to create a new message.
 */
export const ListOfflineQueryShardPerformanceSummariesRequestSchema: GenMessage<ListOfflineQueryShardPerformanceSummariesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_performance_summary, 2);

/**
 * @generated from message chalk.server.v1.ListOfflineQueryShardPerformanceSummariesResponse
 */
export type ListOfflineQueryShardPerformanceSummariesResponse = Message<"chalk.server.v1.ListOfflineQueryShardPerformanceSummariesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ShardPerformanceSummary performance_summaries = 1;
   */
  performanceSummaries: ShardPerformanceSummary[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message chalk.server.v1.ListOfflineQueryShardPerformanceSummariesResponse.
 * Use `create(ListOfflineQueryShardPerformanceSummariesResponseSchema)` to create a new message.
 */
export const ListOfflineQueryShardPerformanceSummariesResponseSchema: GenMessage<ListOfflineQueryShardPerformanceSummariesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_performance_summary, 3);

